export default {
    label: 'Select trend'
}
